import { render, staticRenderFns } from "./GobotWidget.vue?vue&type=template&id=edf7e0fa&scoped=true"
import script from "./GobotWidget.vue?vue&type=script&lang=js"
export * from "./GobotWidget.vue?vue&type=script&lang=js"
import style0 from "./GobotWidget.vue?vue&type=style&index=0&id=edf7e0fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7e0fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edf7e0fa')) {
      api.createRecord('edf7e0fa', component.options)
    } else {
      api.reload('edf7e0fa', component.options)
    }
    module.hot.accept("./GobotWidget.vue?vue&type=template&id=edf7e0fa&scoped=true", function () {
      api.rerender('edf7e0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GobotWidget.vue"
export default component.exports